import update from 'immutability-helper';
import _ from 'lodash';

import { Application } from '../../../types/entities';
import { APPLICATIONS_ACTION_NAMES } from '../../actions/application';

const getApplicationIndex = (state, { id }) => _.findIndex(state, { id });
const getWebhookIndex = (state, { url }) => _.findIndex(state, { url });

export const applications = (state: Application[] = [], action) => {
  switch (action.type) {
    case APPLICATIONS_ACTION_NAMES.APPLICATIONS_GET_SUCCESS:
      return action.payload.responsePayload;

    case APPLICATIONS_ACTION_NAMES.APPLICATION_GET_SUCCESS: {
      return [action.payload.responsePayload, ...state];
    }

    case APPLICATIONS_ACTION_NAMES.APPLICATION_CREATE_SUCCESS:
      return [action.payload, ...state];

    case APPLICATIONS_ACTION_NAMES.APPLICATION_KEY_REGENERATE_SUCCESS:
    case APPLICATIONS_ACTION_NAMES.APPLICATION_UPDATE_SUCCESS:
      return update(state, {
        [getApplicationIndex(state, action.payload)]: { $set: action.payload },
      });

    case APPLICATIONS_ACTION_NAMES.APPLICATION_DELETE_SUCCESS:
      return _.reject(state, { id: action.payload.id });

    case APPLICATIONS_ACTION_NAMES.SECURITY_GROUPS_UPDATE_SUCCESS:
      return update(state, {
        [getApplicationIndex(state, action.payload)]: {
          securityGroups: { $set: action.payload.securityGroups },
        },
      });

    case APPLICATIONS_ACTION_NAMES.WEBHOOK_ADD_SUCCESS:
      return update(state, {
        [getApplicationIndex(state, { id: action.payload.applicationId })]: {
          webhooks: {
            $apply: (webhooks) => [action.payload.webhook, ...webhooks],
          },
        },
      });

    case APPLICATIONS_ACTION_NAMES.WEBHOOK_TOGGLE_ACTIVITY_SUCCESS:
    case APPLICATIONS_ACTION_NAMES.WEBHOOK_TOGGLE_ACTIVITY_ERROR:
    case APPLICATIONS_ACTION_NAMES.WEBHOOK_UPDATE_SUCCESS: {
      const { applicationId, webhook } = action.payload;

      const appIndex = getApplicationIndex(state, { id: applicationId });
      const { webhooks } = state[appIndex];

      return update(state, {
        [appIndex]: {
          webhooks: {
            [getWebhookIndex(webhooks, webhook)]: { $set: webhook },
          },
        },
      });
    }

    case APPLICATIONS_ACTION_NAMES.WEBHOOK_DELETE_SUCCESS: {
      const { applicationId, url } = action.payload;

      const appIndex = getApplicationIndex(state, { id: applicationId });
      const { webhooks } = state[appIndex];

      return update(state, {
        [appIndex]: {
          webhooks: { $set: _.reject(webhooks, { url }) },
        },
      });
    }
    default:
      return state;
  }
};
